import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apartmentsWithDecorationChange } from '../../actions';
import { ApartmentsWithDecoration as ApartmentsWithDecorationComponent } from '../../components/ApartmentsWithDecoration';
import { getApartmentsWithDecoration } from '../../selectors';
import { TThunkDispatch } from '../../types/redux/thunk';
import { setQueryParameter } from '../../utils';

export function ApartmentsWithDecoration() {
  const dispatch: TThunkDispatch = useDispatch();
  const apartmentsWithDecoration = useSelector(getApartmentsWithDecoration);

  const handleApartmentsWithDecorationChange = React.useCallback(
    (event: React.SyntheticEvent, value: boolean) => {
      dispatch(apartmentsWithDecorationChange(value));
      setQueryParameter('apartmentsWithDecoration', value);
    },
    [dispatch],
  );

  return (
    <ApartmentsWithDecorationComponent
      apartmentsWithDecoration={apartmentsWithDecoration}
      onChange={handleApartmentsWithDecorationChange}
    />
  );
}
